var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"lists mt-4 mb-12"},[(_vm.target === 'lecture')?_c('lecture-component',{key:_vm.target}):_c('contents-component',{key:_vm.target,attrs:{"target":_vm.target}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }